import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {ResetStatus as resetStatus} from '../../../../redux/reducers/BRE/AddRuleGroup';
import {
  ResetMessage as resetMessage,
  ResetStatus as resetEventTacticStatus,
} from '../../../../redux/reducers/EventTactics/EventTactics';
import SearchEventTacticContainer from './SearchEventTacticContainer';

function SearchEventTactics({
  setValue,
  value,
  setEventTacticCode,
  setEventClientData,
  eventClientData,
}) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (value === 0) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
      dispatch(resetStatus());
      dispatch(resetEventTacticStatus());
    }
  }, [value]);

  return (
    <>
      <div className="col-md-12">
        <SearchEventTacticContainer
          setValue={setValue}
          setEventTacticCode={setEventTacticCode}
          setEventClientData={setEventClientData}
          eventClientData={eventClientData}
        />
      </div>
    </>
  );
}

export default SearchEventTactics;
